<template>
    <div>

        <PageHeader>
            <span v-if="item">{{ item.name }}</span>
            <b-skeleton v-if="!item && !error" animation="wave" width="45%" height="25px" class="mb-0" />
            <template #side>
                <strong>{{ $t('goBackTo') }}</strong>: <b-link :to="$route.params.parentUrl || parentRoute">
                    {{ $t(parentRoute.meta.title) }}
                </b-link>
            </template>
        </PageHeader>

        <Card :loading="(!item || loading) && !error" class="flex-basis-0 flex-grow-1 width-min-400 mb-auto">

            <ErrorMessage v-if="error" :value="error" :dismissible="false" />

            <b-tabs v-if="item && !error" v-model="tabIndex">
                <b-tab v-for="tabName in tabs" :key="tabName">
                    <template #title>
                        <router-link :to="getTabRouter(tabName)" class="d-flex justify-content-center align-items-center gap-1 px-3 py-2 text-body text-decoration-none font-weight-bold" @click.prevent>
                            {{ $t(`adminCampaignsDetailsTabs.${camelCase(tabName)}`) }}
                            <div v-if="tabsLoading[tabName]" class="tab-spinner"><b-spinner type="border" small /></div>
                            <span v-else-if="Array.isArray(item[tabName]) && item[tabName].length">({{ item[tabName].length }})</span>
                        </router-link>
                    </template>
                    <router-view :name="tabName" />
                </b-tab>
            </b-tabs>

        </Card>

    </div>
</template>



<script>
    import camelCase from 'camelcase';
    import PageHeader from '@/components/common/PageHeader.vue';
    import campaignsService from '@/services/campaignsService';

    export const TABS = ['settings', 'categories', 'commissions', 'feeds', 'offline-locations'];

    export default {
        name: 'WebpagesDetails',
        components: {
            PageHeader,
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            const tabIndex = TABS.findIndex(tab => this.$route.params.tab === tab);
            return {
                camelCase,
                tabs: TABS,
                tabIndex: tabIndex !== -1 ? tabIndex : 0,
                id: Number.parseInt(this.$route.params.id),
                loading: false,
                item: null,
                error: null,
            };
        },
        computed: {
            parentRoute() {
                return this.$route.params.parentUrl ? this.$router.resolve(this.$route.params.parentUrl).resolved : this.$route.matched.slice(-4)[0];
            },
            tabsLoading() {
                return {
                    settings: this.$store.getters['campaigns/getLoading']('campaigns'),
                    categories: this.$store.getters['campaigns/getLoading']('categories'),
                    commissions: this.$store.getters['campaigns/getLoading']('campaignsCommissions'),
                    feeds: this.$store.getters['campaigns/getLoading']('feeds'),
                    'offline-locations': this.$store.getters['campaigns/getLoading']('offlineLocation'),
                };
            },
        },
        watch: {
            tabIndex: {
                handler(tabIndex) {
                    const tabName = TABS[tabIndex];
                    if (tabName !== this.$route.params.tab) {
                        this.$router.push({ name: 'CampaignsDetailsTabIndex', params: { ...this.$route.params, tab: tabName } });
                    }
                },
            },
            '$route.params.tab': {
                handler(tabName) {
                    const tabIndex = TABS.findIndex(tab => tab === tabName);
                    if (tabIndex !== -1 && tabIndex !== this.tabIndex) {
                        this.tabIndex = tabIndex;
                    }
                },
            },
        },
        methods: {
            getTabRouter(tab) {
                return { name: 'CampaignsDetailsTabIndex', params: { ...this.$route.params, tab } };
            },
            loadItem() {
                this.loading = true;
                this.error = null;
                campaignsService
                    .getCampaigns({ urlParams: { id: this.id } })
                    .then(data => (this.item = data))
                    .catch(error => (this.error = error))
                    .finally(() => (this.loading = false));
            },
        },
        created() {
            this.loadItem();
        },
    };
</script>



<style lang="scss" scoped>
    .tab-spinner {
        min-width: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
